// extracted by mini-css-extract-plugin
export var activation = "Profile_activation__Q4E4a";
export var activationContainer = "Profile_activationContainer__iNAyM";
export var container = "Profile_container__jrudi";
export var desktopContainer = "Profile_desktopContainer__OZFCT";
export var desktopReactivate = "Profile_desktopReactivate__Ek6zJ";
export var fileDialog = "Profile_fileDialog__FGl2Z";
export var fullname = "Profile_fullname__J4Hfa";
export var green = "Profile_green__rjJuE";
export var grey = "Profile_grey__BIwmx";
export var header = "Profile_header__alP0D";
export var imageSection = "Profile_imageSection__OyJPZ";
export var left = "Profile_left__qhnNe";
export var lg = "992px";
export var lowerCase = "Profile_lowerCase__Ph2Fe";
export var md = "768px";
export var name = "Profile_name__VjBqj";
export var reactivate = "Profile_reactivate__QsQzL";
export var red = "Profile_red__ozR7p";
export var right = "Profile_right__lKIDx";
export var shared = "\"../shared.module.css\"";
export var statusContainer = "Profile_statusContainer__6MSBJ";
export var subscription = "Profile_subscription__roZl5";
export var subscriptionState = "Profile_subscriptionState__ZgsRF";
export var topContainer = "Profile_topContainer__Dk2dQ";
export var xl = "1200px";